import { useEffect } from 'react';
import { JURISTILIITTO_CONNECTION_ID, useAuth } from './AuthProvider';
import { Box, Typography, CircularProgress } from '@mui/material';

/**
 * A component that immediately triggers the SSO login flow
 * using a connection ID specified in the URL parameters (e.g., ?connection=some-id).
 */
export default function SsoLoginRedirect() {
  const { actions } = useAuth();

  useEffect(() => {
    if (actions) {
      actions.login(JURISTILIITTO_CONNECTION_ID, false);
    }
  }, [actions]);

  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      minHeight='30vh'
      gap={2}
      bgcolor='background.default'
    >
      <CircularProgress />
      <Typography variant='h6'>Ohjataan kirjautumiseen...</Typography>
    </Box>
  );
}
